import { define } from 'wicked-elements'
import astrochimp from 'astrochimp'

define('[data-component~="mailchimp"]', {
  init () {
    this.$form = this.element.querySelector('form')
    this.$error = this.element.querySelector('[data-error]')
    this.$success = this.element.querySelector('[data-success]')
    this.resetTimeout = null
    this.handleSubmit = this.handleSubmit.bind(this)
  },
  connected () {
    this.$form.addEventListener('submit', this.handleSubmit)
  },
  disconnected () {
    this.$form.removeEventListener('submit', this.handleSubmit)
    clearTimeout(this.resetTimeout)
  },
  async handleSubmit (e) {
    e.preventDefault()
    const formData = new FormData(this.$form)
    const data = Object.fromEntries(formData)
    astrochimp(this.$form.action, data, (err, data) => {
      this.$error.innerHTML = ''
      this.$success.innerHTML = ''
      err?.msg && (this.$error.innerHTML = err?.msg.replace('0 - ', ''))
      if (data?.msg) {
        this.$success.innerHTML = data?.msg
        this.resetTimeout = setTimeout(() => {
          this.$form.reset()
          this.$success.innerHTML = ''
        }, 5000)
      }
    })
  }
})